package com.nonopn.skywatcher.common.app.pages.map.view.map

import androidx.compose.foundation.isSystemInDarkTheme
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.padding
import androidx.compose.material.Icon
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.vector.VectorPainter
import com.nonopn.skywatcher.common.app.api.impl.ThunderDetectionSurroundingContext
import com.nonopn.skywatcher.common.app.api.impl.ThunderDetectionSurroundingUser
import com.nonopn.skywatcher.common.app.api.impl.WarnStateValidationState
import com.nonopn.skywatcher.common.app.home.HotPreviewApp
import com.nonopn.skywatcher.common.app.pages.map.model.FakeMainScreenModel
import com.nonopn.skywatcher.common.app.pages.map.model.MainScreenModel
import com.nonopn.skywatcher.design.theme.AppSizes
import com.nonopn.skywatcher.design.theme.LocalApplicationColorTheme
import de.drick.compose.hotpreview.HotPreview
import eu.codlab.compose.widgets.TextNormal

@Composable
fun CounterDefault(
    modifier: Modifier,
    model: MainScreenModel,
    vectorPainter: VectorPainter,
    value: String,
    onClick: (() -> Unit)? = null
) {
    val colors = LocalApplicationColorTheme.current

    MapOverlayCard(
        modifier = modifier,
        onClick = onClick,
    ) {
        Row(
            modifier = Modifier.padding(
                horizontal = AppSizes.map.cardHorizontalPadding,
                vertical = AppSizes.map.cardVerticalPadding
            ),
            horizontalArrangement = Arrangement.spacedBy(AppSizes.map.cardHorizontalPadding),
            verticalAlignment = Alignment.CenterVertically
        ) {
            Icon(
                painter = vectorPainter,
                contentDescription = "-",
                tint = colors.fonts.regular
            )

            Column(Modifier.weight(1.0f)) { /* nothing */ }

            TextNormal(
                text = value
            )
        }
    }
}

@Composable
@HotPreview(widthDp = 150, heightDp = 50, darkMode = true)
@HotPreview(widthDp = 150, heightDp = 50, darkMode = false)
private fun CounterUsersPreview() {
    HotPreviewApp(Modifier.fillMaxSize(), isDarkTheme = isSystemInDarkTheme()) {
        CounterUsers(
            Modifier.fillMaxSize(),
            FakeMainScreenModel(
                false,
                null,
                ThunderDetectionSurroundingContext(
                    (0..94).map {
                        ThunderDetectionSurroundingUser(
                            id = "$it",
                            latitude = 0.0,
                            longitude = 0.0,
                            alertState = WarnStateValidationState.AllClear
                        )
                    }
                ))
        )
    }
}
